"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Environment_1 = require("../../models/Environment");
const lifeConfig = {
    env: Environment_1.BuildEnvironment.Life,
    publicPath: "https://statics.teams.cdn.live.net",
};
exports.default = lifeConfig;
